import { render } from "./HomePage.vue?vue&type=template&id=0ac4f6d0&lang=pug"
import script from "./HomePage.vue?vue&type=script&lang=javascript"
export * from "./HomePage.vue?vue&type=script&lang=javascript"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__